import styles from "./edit-input.module.scss"

const EditInput = ({name, value, placeholder, label, onChange}) => {
    return (
        <div>
            {label && <label className={styles.label}>{label}</label>}
            <input className={styles.input}  onChange={onChange} type="text" name={name} value={value} placeholder={placeholder} />
        </div>
    )
}

export default EditInput;

